module.exports = __webpack_public_path__ + "static/media/dialog-video.5ecf882b.svg";